import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Typography } from '@material-ui/core';
import { DialogWidth, SortingCenterUserRole } from 'types';
import ClosureErrorIcon from '../Icons/ClosureErrorIcon';
import NewDialog from '../NewDialog';
import { ValidateIcon } from '../Icons';

const useStyles = makeStyles(theme => ({
  content: {
    marginBottom: '32px',
    marginRight: '32px',

    '& p': {
      fontSize: 16,
      lineHeight: '24px',
      textAlign: 'left',
      verticalAlign: 'top',
    },
    '& p span': {
      color: '#FF9500',
    },
  },
  bottomButton: {
    textAlign: 'right',
  },
  closeIcon: {
    width: '16px',
  },
  continueIcon: {
    width: '16px',
  },
  continueButton: {
    backgroundColor: '#2F3741',
    color: '#FFFFFF',
    marginLeft: theme.spacing(2),

    '&:hover': {
      color: '#2F3741',
      '& *': {
        color: '#2F3741',
      },
    },
    '&:active': {
      color: '#2F3741',
      '& *': {
        color: '#2F3741',
      },
    },
  },
}));

interface Props {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  sortingCenterUserRole?: SortingCenterUserRole | null;
  handleCancel?: () => void;
  handleContinue?: () => void;
}

export const AdministrationUserDialogDelete: React.FC<Props> = ({
  isOpen,
  setOpen,
  sortingCenterUserRole,
  handleContinue,
  handleCancel,
}) => {
  const classes = useStyles();

  const { t } = useTranslation('translation', {
    keyPrefix: 'administration.users.show.sortingCenterUserRolesList.deletion',
  });

  const handleDefaultCancel = () => {
    setOpen(false);
  };

  return (
    <NewDialog
      closable={true}
      isOpen={isOpen}
      onClose={() => setOpen(false)}
      width={DialogWidth.LARGE_FORM}
      title={t('title')}
      renderContent={() => (
        <div className={classes.content}>
          <Typography>
            {t('textDelete', {
              code: sortingCenterUserRole?.sortingCenter.code,
            })}
          </Typography>
        </div>
      )}
      renderFooter={() => (
        <div className={classes.bottomButton}>
          <Button
            variant="outlined"
            startIcon={<ClosureErrorIcon className={classes.closeIcon} />}
            onClick={handleCancel ? handleCancel : handleDefaultCancel}
          >
            {t('cancel')}
          </Button>
          {handleContinue && (
            <Button
              className={classes.continueButton}
              variant="outlined"
              endIcon={<ValidateIcon className={classes.continueIcon} />}
              onClick={handleContinue}
            >
              {t('continue')}
            </Button>
          )}
        </div>
      )}
    />
  );
};
